var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sc-object-card__list"},_vm._l((_vm.fields),function(field,i){return _c('li',{key:field + i,staticClass:"sc-object-card__list-item"},[_c('list-item-string',{attrs:{"field":field}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }